import React from 'react';
import QuratorHeader from './QuratorHeader';

const QuratorLayout = ({ children }) => {
  return (
    <div className="qurator-shell min-h-screen bg-slate-50 font-sans text-slate-800">
      <QuratorHeader />
      <main className="min-h-[calc(100vh-70px)] bg-slate-50 pt-shellHeaderQurator transition-[padding] lg:pl-quratorSidebar">
        {children}
      </main>
    </div>
  );
};

export default QuratorLayout;
